import { useMutation } from "react-query";
import { deleteHvac } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteHvac = () => {
  return useMutation(deleteHvac);
};
export default useDeleteHvac;
